export interface IHistogeneticsFVHighResTT {
    id: number,
    type: string,
    voucherFirstName: string,
    voucherLastName: string,
    donorAlias: string,
    resultsDateTime: string
}
